import styled, { css } from 'styled-components';
import { always, cond, propEq } from 'ramda';
import Markdown from 'react-markdown';

import { serifFont } from '../layout/layout.styles';
import { media } from '../../utils/media';

const contentColorsStyles = ({ theme }) => css`
  background-color: ${theme.background};
  color: ${theme.color};
`;

const sourceStyles = css`
  font-size: 20px;
  line-height: 1.6em;
  margin-top: 18px;
`;

export const ContentMarkdown = styled(Markdown)`
  ${cond([[propEq('name', 'Source'), always()]])}
`;

export const Blockquote = styled.blockquote`
  ${serifFont};
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  padding: 30px 0;
  margin: 0 0 48px;
  position: relative;

  &::after,
  &::before {
    --sizing: 29px;
    content: '';
    position: absolute;
    top: 0;
    width: var(--sizing);
    height: 100%;
    ${contentColorsStyles}
  }

  &::before {
    left: calc(-1 * var(--sizing));
  }

  &&::after {
    --sizing: 20px;
    right: calc(-1 * var(--sizing));
  }

  ${contentColorsStyles}

  blockquote {
    margin: 0;
    padding: 0;
    ${sourceStyles}
  }

  ${media.desktop`
    width: 100%;
    padding: 30px 35px;
    font-size: 24px;
    line-height: 1.33em;

    &::before, &::after {
      content: none;
    }
  `}

  ${media.desktop`
    margin: 50px 20px;
    width: calc(100% - 40px);
  `}

  ${media.desktopWide`
    margin: 50px 40px;
    width: calc(100% - 80px);
  `}

  @media print {
    margin: 50px 40px;
    width: calc(100% - 80px);
  }
`;
